import React, {useContext, useEffect, useState} from 'react';
import {useSelector} from "react-redux";

import {isLoggedIn} from "../../../../../../data/user.model";
import {getCartData} from "../../../../../../selectors/cart";
import {ProductContext} from "../../../../../pages/ProductStencil";
import {getBasket} from "../../../../../../api/ECOM/getBasket.api";
import {GetBasketItem} from "../../../../../../interfaces/ecom/schema";
import {useI18N} from "../../../../../my-puratos/hoc/withI18N";
import {AddToCartButton} from "./AddToCartButton";
import {AddToCartControls} from "./AddToCartControls";

export const AddToCart = () => {
    if (!isLoggedIn()) {
        return null;
    }

    const {Packaging, activeProductIndex} = useContext(ProductContext);
    const translate = useI18N();

    const {MinimumOrderableQuantity: minQuantity, HasPrice, MaterialNumber} = Packaging[activeProductIndex];
    const cart = useSelector(getCartData);
    const [quantity, setQuantity] = useState(minQuantity || 1);
    const [basket, setBasket] = useState<GetBasketItem[]>([]);
    const [addedToCart, setAddedToCart] = useState(0);
    const [alreadyAdded, setAlreadyAdded] = useState(0);

    const getBasketState = async () => {
        const {BasketItems} = await getBasket();
        setBasket(BasketItems);
    }

    useEffect(() => {
        (async () => {
            try {
                await getBasketState();
            } catch (e) {
                console.error(e);
            }
        })()
    }, [cart])

    useEffect(() => {
        const alreadyAdded = basket.find(item => item.MaterialNumber === MaterialNumber)?.Quantity || 0;
        setAlreadyAdded(alreadyAdded);
    }, [basket, activeProductIndex]);

    useEffect(() => {
        (async () => {
            if (addedToCart) {
                await getBasketState();
            }
        })()
    }, [addedToCart]);

    const addedToCardTranslatedText = alreadyAdded > 0 ?
        (alreadyAdded > 1 ?
            translate('You currently have {0} items in your cart', [`<strong>${alreadyAdded}</strong>`]) :
            translate('You currently have {0} item in your cart', [`<strong>${alreadyAdded}</strong>`])
        ) : false;

    return (
        <>
            <div className={`add-to-cart ${HasPrice ? "add-to-cart" : "add-to-cart add-to-cart--request-price "}`}>
                <AddToCartControls quantity={quantity} setQuantity={setQuantity}/>
                <AddToCartButton
                    quantity={quantity}
                    addedToCart={addedToCart}
                    setAddedToCart={setAddedToCart}
                />
            </div>
            {addedToCardTranslatedText &&
              <p className={"add-to-cart__quantity-info"} dangerouslySetInnerHTML={{__html: addedToCardTranslatedText}}></p>
            }
        </>
    );
};
